const postLoginPayload = (data) => {
  return {
    email: data?.email,
    password: data?.password,
  };
};

export default postLoginPayload;
